module.exports = __webpack_public_path__ + "static/media/arrow-right.ed7d73c6.svg";